module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 039.e1314fa6.jpg";